import { NgModule } from '@angular/core';
import { FileSaverAngularComponent } from './file-saver-angular.component';



@NgModule({
  declarations: [FileSaverAngularComponent],
  imports: [
  ],
  exports: [FileSaverAngularComponent]
})
export class FileSaverAngularModule { }
